var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DateTimeConvertor } from '@shared/utils/Time/DateTimeConvertor';
import { OrderExecutionType } from '@shared/utils/Trading/OrderExecutionType';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { ReportManager } from '@shared/utils/Managers/ReportManager';
import { OrderFormatter } from '../../cache/Formatters/OrderFormatter';
import { TvDurationConvertor } from '../Convertors/TvDurationConvertor';
import { TvOrderConvertor } from '../Convertors/TvOrderConvertor';
import { TvSymbolConvertor } from '../Convertors/TvSymbolConvertor';
import { TvAccountHelper } from '../Helpers/TvAccountHelper';
import { ReportType } from '../../cache/AllowedReport';
export class TvOrdersHistoryManager {
    constructor() {
        this.fakeParentId = 1;
    }
    ordersHistory() {
        return __awaiter(this, void 0, void 0, function* () {
            const startTime = new Date(0).getTime();
            const finishTime = new Date().setHours(23, 59, 59);
            const account = TvAccountHelper.getCurrentAccount();
            const login = account === null || account === void 0 ? void 0 : account.FullAccString;
            ReportManager.reportsByComplited.set(ReportType.REPORT_ORDERBOOK, false);
            const rOrdersHistory = yield ReportManager.sendRequestByDate(ReportType.REPORT_ORDERBOOK, startTime, finishTime, login);
            const allowedOrdersTypes = TvDurationConvertor.getAllAlowedOrderTypes();
            const protectedOrderTypes = TvDurationConvertor.getProtectedOrderTypes();
            const tvOrdersHistory = [];
            for (const rOrderHistory of rOrdersHistory) {
                const executionType = rOrderHistory.eventTypeRaw;
                if (executionType !== OrderExecutionType.REFUSED &&
                    executionType !== OrderExecutionType.FILLED &&
                    executionType !== OrderExecutionType.CANCELED) {
                    continue;
                }
                if (rOrderHistory.Account !== account) {
                    continue;
                }
                // TODO: Why only filled orders?
                if (!allowedOrdersTypes.includes(rOrderHistory.OrderType) &&
                    !protectedOrderTypes.includes(rOrderHistory.OrderType))
                    continue;
                const rOrderType = rOrderHistory.OrderType;
                const orderType = TvOrderConvertor.getTvOrderType(rOrderType);
                const tvOrder = {
                    id: rOrderHistory.FOrderNumber,
                    symbol: this.getSymbol(rOrderHistory),
                    status: this.getTvOrderStatus(rOrderHistory.eventTypeRaw),
                    type: orderType,
                    side: TvOrderConvertor.getTvOrderSide(rOrderHistory.BuySell),
                    qty: rOrderHistory.Quantity,
                    duration: this.getTvOrderDuration(rOrderHistory),
                    updateTime: DateTimeConvertor.ConvertUTCTimeToSelectedTimeZone(rOrderHistory.Date).getTime(),
                    filledQty: rOrderHistory.FFilledQuantity
                };
                if (protectedOrderTypes.includes(rOrderType)) {
                    tvOrder.parentId = this.fakeParentId++;
                    tvOrder.parentType = 2 /* ParentType.Position */;
                }
                if (rOrderType === OrderType.Market) {
                    tvOrder.limitPrice = rOrderHistory.Price;
                }
                else if (rOrderType === OrderType.Limit || rOrderType === OrderType.SLTPLimit) {
                    tvOrder.limitPrice = rOrderHistory.Price;
                }
                else if (rOrderType === OrderType.Stop || rOrderType === OrderType.SLTPStop) {
                    tvOrder.stopPrice = rOrderHistory.Price;
                    tvOrder.stopType = 0; // StopType.Stop
                }
                else if (rOrderType === OrderType.StopLimit) {
                    tvOrder.limitPrice = rOrderHistory.Price;
                    tvOrder.stopPrice = rOrderHistory.StopLimit;
                }
                else if (rOrderType === OrderType.TRStop) {
                    tvOrder.stopPrice = rOrderHistory.Price;
                    tvOrder.stopType = 1; // StopType.TrailingStop
                }
                tvOrder.date = { dateOrDateTime: rOrderHistory.Date.getTime(), hasTime: true };
                const tifType = rOrderHistory.TimeInForce.type;
                const expiration = rOrderHistory.TimeInForce.expirationTime;
                tvOrder.tif = OrderFormatter.GetFormattedValidityStr(tifType, expiration);
                tvOrdersHistory.push(tvOrder);
            }
            return tvOrdersHistory;
        });
    }
    getTvOrderStatus(orderStatus) {
        switch (orderStatus) {
            case OrderExecutionType.FILLED:
                return 2 /* tvOrderStatus.Filled */;
            case OrderExecutionType.CANCELED:
                return 1 /* tvOrderStatus.Canceled */;
            case OrderExecutionType.REFUSED:
            default:
                return 5 /* tvOrderStatus.Rejected */;
        }
    }
    getSymbol(rOrderHistory) {
        if (!isNullOrUndefined(rOrderHistory.Instrument)) {
            return TvSymbolConvertor.getFullname(rOrderHistory.Instrument);
        }
        return rOrderHistory.InstrumentStr;
    }
    getTvOrderDuration(rOrderHistory) {
        const tif = rOrderHistory.TimeInForce.type;
        const expiration = rOrderHistory.TimeInForce.expirationTime;
        return TvOrderConvertor.getTvOrderDuration(tif, expiration);
    }
}
